import React from "react";

import HelpLink from "../HelpLink";

const NavHelpLink = React.forwardRef(
  (props: React.ComponentProps<typeof HelpLink>, ref: React.Ref<any>) => {
    return (
      <HelpLink
        trackingName="nav_help_link"
        trackingUniqueId="nav_help_link"
        ref={ref}
        {...props}
      />
    );
  }
);

export default NavHelpLink;
